
import React, { useState, useEffect } from 'react';
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, Headphones } from "lucide-react";
import AnimatedCard from "@/components/AnimatedCard";
import TrainingHero from "@/components/training/TrainingHero";
import TeamWorkshopsTab from "@/components/training/TeamWorkshopsTab";
import OneOnOneTab from "@/components/training/OneOnOneTab";

const Training = () => {
  const [activeTab, setActiveTab] = useState("team-workshops");
  
  useEffect(() => {
    document.title = "AI Training for Legal Professionals | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Comprehensive AI training for legal teams. Workshops & 1-on-1 sessions. Master AI tools for legal practice.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Comprehensive AI training for legal teams. Workshops & 1-on-1 sessions. Master AI tools for legal practice.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);
  
  return (
    <>
      <Header />
      <main className="pt-24 bg-background min-h-screen">
        <TrainingHero />

        <section className="px-6 py-16 bg-gradient-to-b from-[#0c1427] to-[#111832]">
          <div className="container mx-auto max-w-6xl">
            <AnimatedCard animation="fade-in" delay={400}>
              <Tabs defaultValue="team-workshops" className="w-full" onValueChange={setActiveTab}>
                <TabsList className="grid grid-cols-1 md:grid-cols-2 w-full mb-10 bg-white/10 backdrop-blur-sm border border-white/20 shadow-lg p-2 rounded-xl h-auto">
                  <TabsTrigger 
                    value="team-workshops" 
                    className="flex items-center gap-3 text-sm md:text-base py-4 px-6 rounded-lg font-medium transition-all duration-300 data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow-lg data-[state=active]:border-primary/50 border border-transparent hover:bg-white/10 hover:text-white text-white/70"
                  >
                    <Users className="h-5 w-5" />
                    <span className="hidden sm:inline">Team Workshops</span>
                    <span className="sm:hidden">Workshops</span>
                  </TabsTrigger>
                  <TabsTrigger 
                    value="one-on-one" 
                    className="flex items-center gap-3 text-sm md:text-base py-4 px-6 rounded-lg font-medium transition-all duration-300 data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow-lg data-[state=active]:border-primary/50 border border-transparent hover:bg-white/10 hover:text-white text-white/70"
                  >
                    <Headphones className="h-5 w-5" />
                    <span className="hidden sm:inline">1-1 Training</span>
                    <span className="sm:hidden">1-1 Training</span>
                  </TabsTrigger>
                </TabsList>
                
                <TabsContent value="team-workshops">
                  <TeamWorkshopsTab />
                </TabsContent>
                
                <TabsContent value="one-on-one">
                  <OneOnOneTab />
                </TabsContent>
              </Tabs>
            </AnimatedCard>
          </div>
        </section>
      </main>
      <FooterSection />
    </>
  );
};

export default Training;
